import { lazy } from 'react';
import {
    CREATE_PERMISSION,
    INVOICES_AUTH,
    READ_PERMISSION,
    UPDATE_PERMISSION,
} from 'src/constants/permissions';
import { PermissionsGuard } from 'src/routing/components';

export const Routes = [
    {
        exact: true,
        path: '/create/:id/closure',
        guard: PermissionsGuard,
        roles: {
            permission: INVOICES_AUTH,
            crud: CREATE_PERMISSION,
        },
        component: lazy(() => import('src/views/closures/ClosureCreateView')),
    },
    {
        exact: true,
        guard: PermissionsGuard,
        roles: {
            permission: INVOICES_AUTH,
            crud: READ_PERMISSION,
        },
        path: '/management/closures/:id',
        component: lazy(() => import('src/views/closures/ClosureDetailsView')),
    },
    {
        exact: true,
        guard: PermissionsGuard,
        roles: {
            permission: INVOICES_AUTH,
            crud: UPDATE_PERMISSION,
        },
        path: '/management/closures/:id/edit',
        component: lazy(() => import('src/views/closures/ClosureEditView')),
    },
    {
        exact: true,
        guard: PermissionsGuard,
        roles: {
            permission: INVOICES_AUTH,
            crud: READ_PERMISSION,
        },
        path: '/management/closures',
        component: lazy(() => import('src/views/closures/ClosureListView')),
    },
];
